import type { WebsiteHeaderPhotoSchema_FullWidth } from '@shared/types/WebsiteHeaderSettings.types';

export const FULL_WIDTH_DEFAULT: WebsiteHeaderPhotoSchema_FullWidth = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/fullWidth-v1_1_1.json',
  presentationLayout: 'fullWidth',
  photos: [],
};
